import { render, staticRenderFns } from "./QuatetionList.vue?vue&type=template&id=706360cc&scoped=true"
import script from "./QuatetionList.vue?vue&type=script&lang=js"
export * from "./QuatetionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706360cc",
  null
  
)

export default component.exports